export default "__VITE_ASSET__nNWEubeG__"